import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as componentTypes from "../constants/componentTypes";
import * as config from "../constants/config";
import * as rcc from "../constants/rcc";
import * as windowService from "../services/windowService";
import * as formatHelper from "../helpers/formatHelper";
import * as messageHelper from "../helpers/messageHelper";
import * as modelHelper from "../helpers/modelHelper";
import * as translationHelper from "../helpers/translationHelper";
import * as handlers from "../constants/handlers";

export const rccConnect = (ip) => ({
    type: actionTypes.RCC_CONNECT,
    payload: {
        url: config.WEBSOCKET_PROTOCOL + ip + ":" + config.RCC_PORT
    }
});

export const saveRccUrl = (url) => ({
    type: actionTypes.RCC_SET_URL,
    payload: {
        url: url
    }
});

export const rccDisconnect = () => ({
    type: actionTypes.RCC_DISCONNECT
});

export const websocketConnecting = () => {
    windowService.logInfo("Connecting to RCC websocket.");

    return {
        type: actionTypes.RCC_WEBSOCKET_CONNECTING
    };
};

export const websocketOpened = () => {
    windowService.logInfo("RCC websocket opened.");

    return {
        type: actionTypes.RCC_WEBSOCKET_OPENED
    };
};

export const websocketClosed = (event) => {
    windowService.logInfo(event.reason !== "" ? "RCC websocket closed: " + event.reason : "RCC websocket closed.");

    return {
        type: actionTypes.RCC_WEBSOCKET_CLOSED
    };
};

export const websocketError = () => {
    windowService.logInfo("RCC websocket error.");

    return {
        type: actionTypes.RCC_WEBSOCKET_ERROR
    };
};

export const websocketResponse = (event) => {
    return {
        type: actionTypes.RCC_WEBSOCKET_RESPONSE,
        payload: {
            data: event.data
        }
    };
};

/**
 * @param   {Number}    sequence
 * @param   {Number}    tabId
 * @param   {String}    method
 * @param   {Object}    nextRequest
 * @returns {Object}
 */
export const saveWebsocketRequest = (sequence, tabId, method, nextRequest) => ({
    type: actionTypes.SAVE_RCC_WEBSOCKET_REQUEST,
    payload: {
        sequence: sequence,
        tabId: tabId,
        method: method,
        next: nextRequest
    }
});

export const websocketRequest = (payload) => ({
    type: actionTypes.RCC_WEBSOCKET_REQUEST,
    payload: payload
});

/**
 * @param   {Number}    tabId
 * @param   {Object}    payload
 * @param   {String}    method
 * @param   {Object}    next
 * @returns {Function}
 */
export const processSimpleWebsocketRequest = (tabId, payload, method, next = null) => {
    return (dispatch, getState) => {
        let sequence = getState().rcc.sequence + 1;

        dispatch(saveWebsocketRequest(sequence, tabId, method, next));

        payload.sequence = sequence;

        return dispatch(websocketRequest(payload));
    };
};

/**
 * @param   {Number}    tabId
 * @param   {Object}    payload
 * @param   {String}    method
 * @param   {Boolean}   safe
 * @returns {Function}
 */
export const processWebsocketRequest = (tabId, payload, method, safe) => {
    return (dispatch, getState) => {
        let sequence = getState().rcc.sequence + 1;

        if (safe) {
            let nextRequest = {
                type: actionTypes.RCC_REQUEST,
                payload: payload,
                tabId: tabId,
                method: method,
                safe: false
            };

            dispatch(saveWebsocketRequest(sequence, tabId, handlers.MACHINE_CONNECTION_TEST, nextRequest));

            payload.sequence = sequence;

            return dispatch(websocketRequest({type: methods.METHOD_MACHINE_IS_CONNECTED, sequence: sequence}));
        }

        dispatch(saveWebsocketRequest(sequence, tabId, method, null));

        payload.sequence = sequence;

        return dispatch(websocketRequest(payload));
    };
};

/**
 * @param   {Number}    tabId
 * @param   {Object}    payload
 * @param   {String}    method
 * @param   {Boolean}   safe        - checks if spectro is connected to RCC
 * @param   {Boolean}   safer       - checks if spectro is selected from RCC
 * @returns {Function}
 */
export const processSpectroWebsocketRequest = (tabId, payload, method, safe, safer = false, next = null) => {
    return (dispatch, getState) => {
        let sequence = getState().rcc.sequence + 1;

        if (safer) {
            let nextRequest = {
                type: actionTypes.RCC_SPECTRO_REQUEST,
                payload: payload,
                tabId: tabId,
                method: method,
                safe: safe,
                safer: false,
                next: next
            };

            dispatch(saveWebsocketRequest(sequence, tabId, handlers.SPECTRO_SELECTION_TEST, nextRequest));

            payload.sequence = sequence;

            return dispatch(websocketRequest({type: methods.METHOD_SPECTRO_IS_SELECTED, sequence: sequence}));
        }

        /*if (safe) {
            let nextRequest = {
                type: actionTypes.RCC_SPECTRO_REQUEST,
                payload: payload,
                tabId: tabId,
                method: method,
                safe: false,
                safer: false
            };

            dispatch(saveWebsocketRequest(sequence, tabId, handlers.SPECTRO_CONNECTION_TEST, nextRequest));

            payload.sequence = sequence;

            return dispatch(websocketRequest({type: methods.METHOD_SPECTRO_IS_CONNECTED, sequence: sequence}));
        }*/

        dispatch(saveWebsocketRequest(sequence, tabId, method, next));

        payload.sequence = sequence;

        return dispatch(websocketRequest(payload));
    };
};

export const connectMachine = () => ({
    type: actionTypes.MACHINE_CONNECT
});

export const disconnectMachine = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_DISCONNECT
    },
    method: handlers.MACHINE_START_DISCONNECT,
    tabId: 0,
    safe: true
});

export const initializeMachine = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_INITIALIZE
    },
    method: handlers.MACHINE_START_INITIALIZE,
    tabId: 0,
    safe: true
});

export const resetMachine = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_RESET
    },
    method: handlers.MACHINE_START_RESET,
    tabId: 0,
    safe: true
});

export const hardResetMachine = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_HARD_RESET
    },
    method: handlers.MACHINE_START_HARD_RESET,
    tabId: 0,
    safe: true
});

export const errorsResetMachine = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_ERRORS_RESET
    },
    method: handlers.MACHINE_START_ERRORS_RESET,
    tabId: 0,
    safe: true
});

export const startOrderDispensing = (tabId, orderId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_COLOR_STATS_FROM_ORDER,
        params: {
            orderRecordId: orderId
        }
    },
    method: handlers.ADD_COLOR_STATS_FROM_ORDER,
    tabId: tabId
});

export const saveOrderDirectlyToStatistics = (tabId, orderId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_COLOR_STATS_FROM_ORDER,
        params: {
            orderRecordId: orderId
        }
    },
    method: handlers.ADD_COLOR_STATS_FROM_ORDER_DIRECTLY,
    tabId: tabId
});

export const initQuickDispensing = (formula, dispense, load) => ({
    type: actionTypes.INIT_QUICK_DISPENSING,
    payload: {
        formula: formula,
        dispense: dispense,
        load: load
    }
});

export const startQuickDispensing = (tabId) => ({
    type: actionTypes.START_QUICK_DISPENSING,
    payload: {
        tabId: tabId
    }
});

export const dialogBtnAction = (dialogId, btnKey) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK,
        params: {
            dialogID: dialogId,
            msgBtn: btnKey
        }
    },
    method: handlers.MACHINE_DIALOG_BUTTON_CLICK,
    tabId: 0,
    safe: false
});

export const moveTableToRefill = (canisterIndex) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_MOVE_TABLE_TO_REFILL,
        params: {
            index: canisterIndex
        }
    },
    method: handlers.MACHINE_MOVE_TABLE_TO_REFILL,
    tabId: 0,
    safe: true
});

export const confirmCanisterRefill = (index, level, add, unitMl, type = rcc.RCC_REFILL) => ({
    type: actionTypes.MACHINE_CONFIRM_REFILL_VALIDATION,
    payload: {
        index: index,
        level: level,
        add: add,
        unitMl: unitMl,
        type: type
    }
});

export const refillCanister = (index, level, add, unitMl, ufiCode, batchNumber, type = rcc.RCC_REFILL) => ({
    type: actionTypes.MACHINE_REFILL_CANISTER,
    payload: {
        index: index,
        level: level,
        add: add,
        unitMl: unitMl,
        ufiCode: ufiCode,
        batchNumber: batchNumber,
        type: type
    }
});

export const setMaxDispenseLevel = (canisterIndex, amount) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SET_MAX_DISPENSE_LEVEL,
        params: {
            index: canisterIndex,
            amount: amount
        }
    },
    method: handlers.MACHINE_SET_MAX_DISPENSE_LEVEL,
    tabId: 0,
    safe: true
});

export const setDispenseLogicType = (canisterIndex, type) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SET_CANISTER_DISPENSE_LOGIC_TYPE,
        params: {
            index: canisterIndex,
            dispenseLogicType: type
        }
    },
    method: handlers.MACHINE_SET_CANISTER_DISPENSE_LOGIC_TYPE,
    tabId: 0,
    safe: true
});

export const moveShelf = (position) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_SHELF,
        params: {
            position: position
        }
    },
    method: handlers.MACHINE_START_SHELF,
    tabId: 0,
    safe: true
});

export const machinePunch = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_PUNCH
    },
    method: handlers.MACHINE_START_PUNCH,
    tabId: 0,
    safe: true
});

export const machinePlug = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_PLUG
    },
    method: handlers.MACHINE_START_PLUG,
    tabId: 0,
    safe: true
});

export const machineCap = (position) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_CAP,
        params: {
            position: position
        }
    },
    method: handlers.MACHINE_START_CAP,
    tabId: 0,
    safe: true
});

export const showServiceWindow = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SHOW_SERVICE_WINDOW
    },
    method: handlers.MACHINE_SHOW_SERVICE_WINDOW,
    tabId: 0,
    safe: true
});

export const cleanChannels = (channels, time) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_CLEAN_CHANNELS,
        params: {
            channels: channels,
            cleaningTime: time
        }
    },
    method: handlers.MACHINE_START_CLEAN_CHANNELS,
    tabId: 0,
    safe: true
});

export const recirculateChannels = (channels, time, speed) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_RECIRCULATE_CHANNELS,
        params: {
            channels: channels,
            recirculationSpeed: speed,
            recirculationTime: time
        }
    },
    method: handlers.MACHINE_START_RECIRCULATE_CHANNELS,
    tabId: 0,
    safe: true
});

export const recirculateAllChannels = (time, speed) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_RECIRCULATE_ALL,
        params: {
            recirculationSpeed: speed,
            recirculationTime: time
        }
    },
    method: handlers.MACHINE_START_RECIRCULATE_ALL,
    tabId: 0,
    safe: true
});

export const cleanAllChannels = (time) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_CLEAN_ALL,
        params: {
            cleaningTime: time
        }
    },
    method: handlers.MACHINE_START_CLEAN_ALL,
    tabId: 0,
    safe: true
});

export const stirCanisters = (canisters, stirringTime, stirringSpeed) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_STIR_CANISTERS,
        params: {
            canisters: canisters,
            stirringTime: stirringTime,
            stirringSpeed: stirringSpeed
        }
    },
    method: handlers.MACHINE_START_STIR_CANISTERS,
    tabId: 0,
    safe: true
});

export const stirAllCanisters = (stirringTime, stirringSpeed) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_STIR_ALL,
        params: {
            stirringTime: stirringTime,
            stirringSpeed: stirringSpeed
        }
    },
    method: handlers.MACHINE_START_STIR_ALL,
    tabId: 0,
    safe: true
});

/**
 *
 * @param {Array of Objects} channels
 */

export const purgeChannels = (channels) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_PURGE,
        params: {
            formula: channels,
            shelf: [-1, 0, -1]
        }
    },
    method: handlers.MACHINE_START_PURGE,
    tabId: 0,
    safe: true
});

export const purgeAllChannels = (volume) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_PURGE_ALL,
        params: {
            volume: volume,
            shelf: [-1, 0, -1]
        }
    },
    method: handlers.MACHINE_START_PURGE_ALL,
    tabId: 0,
    safe: true
});

/**
 *
 * @param {Array of Numbers} channels
 */

export const smartPurgeChannels = (channels) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_SMART_PURGE,
        params: {
            channels: channels,
            shelf: [-1, 0, -1]
        }
    },
    method: handlers.MACHINE_START_SMART_PURGE,
    tabId: 0,
    safe: true
});

export const smartPurgeAllChannels = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_SMART_PURGE_ALL,
        params: {
            shelf: [-1, 0, -1]
        }
    },
    method: handlers.MACHINE_START_SMART_PURGE_ALL,
    tabId: 0,
    safe: true
});

export const connectSpectro = () => ({
    type: actionTypes.RCC_SPECTRO_REQUEST,
    payload: {
        type: methods.METHOD_SPECTRO_IS_CONNECTED
    },
    method: handlers.SPECTRO_IS_CONNECTED,
    tabId: 0,
    safe: false
});

export const spectroDialogBtnAction = (dialogId, btnKey) => ({
    type: actionTypes.RCC_SPECTRO_REQUEST,
    payload: {
        type: methods.METHOD_SPECTRO_DIALOG_BUTTON_CLICK,
        params: {
            dialogID: dialogId,
            msgBtn: btnKey
        }
    },
    method: handlers.SPECTRO_DIALOG_BUTTON_CLICK,
    tabId: 0,
    safe: false
});

export const startCalibrateSpectro = () => ({
    type: actionTypes.RCC_SPECTRO_REQUEST,
    payload: {
        type: methods.METHOD_SPECTRO_START_CALIBRATE
    },
    method: handlers.SPECTRO_START_CALIBRATE,
    tabId: 0,
    safe: true,
    safer: true
});

export const startMeasureSpectro = (tabId = 0, callback = null) => ({
    type: actionTypes.RCC_SPECTRO_REQUEST,
    payload: {
        type: methods.METHOD_SPECTRO_START_MEASURE
    },
    method: handlers.SPECTRO_START_MEASURE,
    tabId: tabId,
    safe: true,
    safer: true,
    next: callback
});

export const saveSpectroManualInput = (lab, rgbHex, rgb, xyz) => ({
    type: actionTypes.SAVE_SPECTRO_MEASURE_RESULT,
    payload: {
        result: modelHelper.mapSpectralDataToObject(rgb, lab, xyz, rgbHex, null)
    }
});

export const resetSpectroResult = () => ({
    type: actionTypes.SAVE_SPECTRO_MEASURE_RESULT,
    payload: {
        result: null
    }
});

export const getPrintTemplatesList = () => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_PRINTER_GET_TEMPLATES_LIST
    },
    method: handlers.PRINTER_GET_TEMPLATES_LIST,
    tabId: 0
});

/**
 * @param {Number | null}   tabId
 * @param {String | null}   template
 * @param {Object | null}   printValues
 * @param {Object | null}   formula
 * @param {Object | null}   printData
 * @param {String | null}   moreInfoText
 * @param {String | null}   dispenseNote
 *
 * @returns {Object}
 */
export const getPrintPreviewImage = (
    tabId,
    template = null,
    printValues = null,
    formula = null,
    printData = null,
    moreInfoText = null,
    dispenseNote = null,
    moreInfoInternal = null
) => {
    return {
        type: actionTypes.GET_PRINT_PREVIEW_IMAGE,
        payload: {
            tabId: tabId,
            template: template,
            printValues: printValues,
            formula: formula,
            printData: printData,
            moreInfoText: moreInfoText,
            dispenseNote: dispenseNote,
            moreInfoInternal: moreInfoInternal
        }
    };
};

/**
 * @param {Number | null}   tabId
 * @param {String | null}   template
 * @param {Object | null}   printValues
 * @param {Object | null}   formula
 * @param {Object | null}   printData
 * @param {String | null}   moreInfoText
 * @param {String | null}   dispenseNote
 *
 * @returns {Object}
 */
export const exportPrintPreviewToPdf = (
    tabId,
    template = null,
    printValues = null,
    formula = null,
    printData = null,
    moreInfoText = null,
    dispenseNote = null
) => {
    return {
        type: actionTypes.EXPORT_PRINT_PREVIEW_TO_PDF,
        payload: {
            tabId: tabId,
            template: template,
            printValues: printValues,
            formula: formula,
            printData: printData,
            moreInfoText: moreInfoText,
            dispenseNote: dispenseNote
        }
    };
};

/**
 * @param {Number | null}   tabId
 * @param {String | null}   template
 * @param {String | null}   printer
 * @param {Number | null}   pages
 * @param {Object | null}   printValues
 * @param {Object | null}   formula
 * @param {Object | null}   printData
 * @param {String | null}   moreInfoText
 * @param {String | null}   dispenseNote
 *
 * @returns {Object}
 */
export const startPrintReportSilent = (
    tabId,
    template = null,
    printer = null,
    pages = null,
    printValues = null,
    formula = null,
    printData = null,
    moreInfoText = null,
    dispenseNote = null,
    moreInfoInternal = null
) => {
    return {
        type: actionTypes.START_PRINT_REPORT_SILENT,
        payload: {
            tabId: tabId,
            template: template,
            printer: printer,
            pages: pages,
            printValues: printValues,
            formula: formula,
            printData: printData,
            moreInfoText: moreInfoText,
            dispenseNote: dispenseNote,
            moreInfoInternal: moreInfoInternal
        }
    };
};

export const printFormulaFromQuickTint = (
    printerName,
    templateName,
    formula,
    formulaUnits,
    pos,
    clientIdentifier,
    printAsImage,
    userName,
    tintometricSystem
) => {
    let date = new Date();

    return {
        type: actionTypes.RCC_REQUEST,
        payload: {
            type: methods.METHOD_RCC_PRINT_FORMULA_SILENT,
            params: {
                printerName: printerName,
                template: templateName,
                pages: 1,
                printAsImage: printAsImage,
                values: {
                    client_name: clientIdentifier,
                    tintometric_system: tintometricSystem,
                    scaling: 100,
                    formula_note: null,
                    dispensing_note: null,
                    dispensing_more_info_internal: null,
                    user: userName,
                    building_site: null,
                    ...formula.getPrintData(formulaUnits),
                    ...translationHelper.getPrinterTemplateTranslation(),
                    currdate: formatHelper.formatDate(date),
                    currdatetime: formatHelper.formatDateTime(date),
                    currtime: formatHelper.formatTime(date),
                    color: formula.name,
                    color_name: formula.displayName,
                    colorname: formula.displayName,
                    color_display_name: formula.displayName,
                    color_print_name: formula.displayName,
                    posname: pos === null || pos.shopName === null ? "" : pos.shopName,
                    posaddress: pos === null || pos.address === null ? "" : pos.address,
                    posaddress2: pos === null || pos.secondAddress === null ? "" : pos.secondAddress,
                    poscity: pos === null || pos.city === null ? "" : pos.city,
                    poszipcode: pos === null || pos.zipCode === null ? "" : pos.zipCode,
                    poscontact: pos === null || pos.contactName === null ? "" : pos.contactName,
                    posemail: pos === null || pos.email === null ? "" : pos.email,
                    posphone: pos === null || pos.phone === null ? "" : pos.phone,
                    posurl: pos === null || pos.url === null ? "" : pos.url,
                    packageordercount: "1/1"
                }
            }
        },
        method: handlers.RCC_PRINT_FORMULA_SILENT,
        tabId: 0,
        safe: false
    };
};

export const setDriverDefault = (type) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverLLD = (type, path, dispenser) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                LLD: {
                    hld_path: path,
                    dispenser: dispenser
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverSimulation = (type, path) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                Simulation: {
                    path: path
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverManual = (type, path) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                Manual: {
                    path: path
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverManualSimple = (type, path) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                ManualSimple: {
                    path: path
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverDromontV2 = (type, path) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                DromontV2: {
                    folder: path
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverAlfaRestApi = (type, host, port) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                AlfaRestApi: {
                    port: port,
                    host: host
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverFluidIDD = (type, path) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                FluidIDD: {
                    path: path
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverFluidUIDD = (type, host, port, user, password) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                FluidUIDD: {
                    host: host,
                    port: port,
                    user: user,
                    password: password
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverItaltinto = (type, path) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                Italtinto: {
                    path: path
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverDromont = (type, path, extensionPath, formulaPath) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                DromontMisura: {
                    driver_path: path,
                    extension_path: extensionPath,
                    formula_path: formulaPath
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setDriverDromontDDRV = (type, path, resultPath, databasePath, serviceSwPath) => ({
    type: actionTypes.RCC_SIMPLE_REQUEST,
    payload: {
        type: methods.METHOD_SET_DRIVER_CONFIGURATION,
        params: {
            value: {
                General: {
                    type: type
                },
                DromontDDRV: {
                    driver_path: path,
                    result_path: resultPath,
                    database_path: databasePath,
                    service_sw_path: serviceSwPath
                }
            }
        }
    },
    method: handlers.SET_DRIVER_CONFIGURATION,
    tabId: 0
});

export const setMachineConfiguration = (configuration) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SET_CONFIGURATION,
        params: {
            value: configuration
        }
    },
    method: handlers.MACHINE_SET_CONFIGURATION,
    tabId: 0,
    safe: false
});

export const setMinimalDispenseAmount = (minimalDispenseAmount) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SET_CONFIGURATION,
        params: {
            value: {
                minimal_dispense_amount: minimalDispenseAmount
            }
        }
    },
    method: handlers.INTERGAMMA_MACHINE_SET_DISPENSE_LEVEL,
    tabId: 0,
    safe: false
});

export const rccNeedRestartMessage = () => {
    return messageHelper.getWarningMessageAction("flashMessage.rccNeedRestart");
};

export const getMachineRefillHistoryWithOffset = (index, offset = 0, rowCount = config.MAX_COLORANT_LIMIT) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_HISTORY_REFILLS,
        params: {
            index: index,
            offset: offset,
            rowCount: rowCount
        }
    },
    method: handlers.MACHINE_HISTORY_REFILLS_WITH_OFFSET,
    tabId: 0,
    safe: true
});

export const getMachineRefillHistory = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_HISTORY_REFILLS
    },
    method: handlers.MACHINE_HISTORY_REFILLS,
    tabId: 0,
    safe: true
});

export const getCanisterRefillHistory = (index, offset = 0, rowCount = config.MAX_COLORANT_LIMIT) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_HISTORY_REFILLS,
        params: {
            index: index,
            offset: offset,
            rowCount: rowCount
        }
    },
    method: handlers.MACHINE_HISTORY_REFILLS,
    tabId: 0,
    safe: true
});

export const getCanisterUfiCodes = (index) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_GET_CANISTER_UFI_CODES,
        params: {
            index: index
        }
    },
    method: handlers.MACHINE_GET_UFI_CODES,
    tabId: 0,
    safe: true
});

export const updateRefillValidationWizard = (index) => ({
    type: actionTypes.MACHINE_UPDATE_REFILL_VALIDATION_WIZARD,
    payload: {
        index: index
    }
});

export const spectroIsSelectedAction = () => ({
    type: actionTypes.RCC_SPECTRO_REQUEST,
    payload: {
        type: methods.METHOD_SPECTRO_IS_SELECTED
    },
    method: handlers.SPECTRO_SELECTION_MANUAL_TEST,
    tabId: 0,
    safe: false
});

export const setCanisterBarcode = (index, barcode) => ({
    type: actionTypes.MACHINE_VALIDATE_CANISTER_BARCODE,
    payload: {
        index: index,
        barcode: barcode
    }
});

export const setCanisterThreshold = (index, thresholdPercent) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SET_CANISTER_THRESHOLD_PERCENT,
        params: {
            index: index,
            thresholdPercent: thresholdPercent
        }
    },
    method: handlers.MACHINE_SET_CANISTER_THRESHOLD,
    tabId: 0,
    safe: true
});

export const getCanisterByBarcode = (barcode) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_GET_CANISTER_BY_BARCODE,
        params: {
            barcode: barcode
        }
    },
    method: handlers.MACHINE_GET_CANISTER_BY_BARCODE,
    tabId: 0,
    safe: true
});

export const resetRefillValidation = () => ({
    type: actionTypes.MACHINE_RESET_REFILL_VALIDATION
});

export const startCanisterRefill = (index) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_START_CANISTER_REFILL,
        params: {
            index: index
        }
    },
    method: handlers.MACHINE_START_CANISTER_REFILL,
    tabId: 0,
    safe: true
});

export const savePos = (posInfo) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_POS_INFO,
        params: {
            info: {
                name: posInfo.shopName,
                url: posInfo.url,
                zipCode: posInfo.zipCode,
                address: posInfo.address,
                email: posInfo.email,
                address2: posInfo.secondAddress,
                phone: posInfo.phone,
                city: posInfo.city,
                contact: posInfo.contactName,
                identification: posInfo.shopIdentification,
                machineIdentification: posInfo.machineIdentification
            }
        }
    },
    method: handlers.GET_POS_INFO,
    tabId: 0
});

export const backupMachineConfiguration = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_BACKUP_CONFIGURATION
    },
    method: handlers.MACHINE_BACKUP_CONFIGURATION,
    tabId: 0,
    safe: true
});

export const getCanisterImage = (canister) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_GET_CANISTER_IMAGE,
        params: {
            index: canister.id
        }
    },
    method: handlers.MACHINE_GET_CANISTER_IMAGE,
    tabId: 0,
    safe: true
});

export const getPurgeRulesList = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_PURGE_RULES_LIST
    },
    method: handlers.MACHINE_PURGE_RULES_LIST,
    tabId: 0,
    safe: true
});

export const addPurgeRule = (rule) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_PURGE_RULE_ADD,
        params: {
            index: rule.index,
            purgeVolume: rule.volume,
            minDispensedVolume: rule.minDispensedVolume,
            excludePurge: rule.excludePurge,
            priority: rule.priority,
            note: rule.note
        }
    },
    method: handlers.MACHINE_PURGE_RULE_ADD,
    tabId: 0,
    safe: true
});

export const editPurgeRule = (rule) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_PURGE_RULE_UPDATE,
        params: {
            id: rule.id,
            index: rule.index,
            purgeVolume: rule.volume,
            minDispensedVolume: rule.minDispensedVolume,
            excludePurge: rule.excludePurge,
            priority: rule.priority,
            note: rule.note
        }
    },
    method: handlers.MACHINE_PURGE_RULE_UPDATE,
    tabId: 0,
    safe: true
});

export const setManualColorantAdditionUnit = (unit) => ({
    type: actionTypes.SET_MANUAL_COLORANT_ADDITION_UNIT,
    payload: {
        unit: unit
    }
});

export const getPurgeStats = (startDate, endDate) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_GET_PURGE_STATS,
        params: {
            startDate: startDate !== null ? formatHelper.formatDateTimeForServer(startDate) : null,
            endDate: endDate !== null ? formatHelper.formatDateTimeForServer(endDate) : null
        }
    },
    method: handlers.MACHINE_GET_PURGE_STATS,
    tabId: 0,
    safe: true
});

export const getDispenseStats = (startDate, endDate) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_GET_DISPENSE_STATS,
        params: {
            startDate: startDate !== null ? formatHelper.formatDateTimeForServer(startDate) : null,
            endDate: endDate !== null ? formatHelper.formatDateTimeForServer(endDate) : null
        }
    },
    method: handlers.MACHINE_GET_DISPENSE_STATS,
    tabId: 0,
    safe: true
});

export const getAllStats = (startDate, endDate) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_GET_ALL_STATS,
        params: {
            startDate: startDate !== null ? formatHelper.formatDateTimeForServer(startDate) : null,
            endDate: endDate !== null ? formatHelper.formatDateTimeForServer(endDate) : null
        }
    },
    method: handlers.MACHINE_GET_ALL_STATS,
    tabId: 0,
    safe: true
});

export const purgeStatsInit = () => ({
    type: actionTypes.PURGE_STATS_INIT,
    payload: {
        tabId: componentTypes.PURGE_STATS_SUBMENU
    }
});

export const closePurgeStats = () => ({
    type: actionTypes.PURGE_STATS_EXIT,
    payload: {
        tabId: componentTypes.PURGE_STATS_SUBMENU
    }
});

export const colorantRefillHistoryInit = () => ({
    type: actionTypes.COLORANT_REFILL_HISTORY_INIT,
    payload: {
        tabId: componentTypes.COLORANT_REFILL_HISTORY_SUBMENU
    }
});

export const closeColorantRefillHistory = () => ({
    type: actionTypes.COLORANT_REFILL_HISTORY_EXIT,
    payload: {
        tabId: componentTypes.COLORANT_REFILL_HISTORY_SUBMENU
    }
});

export const getMachineCanisters = () => {
    return {
        type: actionTypes.RCC_REQUEST,
        payload: {
            type: methods.METHOD_MACHINE_CANISTERS
        },
        method: handlers.MACHINE_CANISTERS,
        tabId: 0,
        safe: false
    };
};

export const saveActiveCanister = (canister) => {
    return {
        type: actionTypes.SAVE_ACTIVE_CANISTER,
        payload: {
            canister: canister
        }
    };
};

export const exportChannelAllStats = (dateFrom, dateTo) => ({
    type: actionTypes.PREPARE_FILE_CHANNEL_ALL_STATS_DATA,
    payload: {
        dateFrom: dateFrom,
        dateTo: dateTo
    }
});

export const exportChannelDispenseStats = (dateFrom, dateTo) => ({
    type: actionTypes.PREPARE_FILE_CHANNEL_DISPENSE_STATS_DATA,
    payload: {
        dateFrom: dateFrom,
        dateTo: dateTo
    }
});

export const exportChannelPurgeStats = (dateFrom, dateTo) => ({
    type: actionTypes.PREPARE_FILE_CHANNEL_PURGE_STATS_DATA,
    payload: {
        dateFrom: dateFrom,
        dateTo: dateTo
    }
});

export const setCanisterUfiCode = (index, ufiCode) => {
    return {
        type: actionTypes.RCC_REQUEST,
        payload: {
            type: methods.METHOD_MACHINE_SET_CANISTER_UFI_CODE,
            params: {
                index: index,
                ufiCode: ufiCode
            }
        },
        method: handlers.MACHINE_SET_CANISTER_UFI_CODE,
        tabId: 0,
        safe: false
    };
};

export const reloadFormulaMetaDataWithUfi = (ufiCode) => {
    return {
        type: actionTypes.RELOAD_FORMULA_META_DATA_WITH_UFI,
        payload: {
            ufiCode: ufiCode
        }
    };
};

export const setBatchUseLastRefill = (batchUseLastRefill) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SET_CONFIGURATION,
        params: {
            value: {
                batch_use_last_refill: batchUseLastRefill
            }
        }
    },
    method: handlers.MACHINE_SET_CONFIGURATION,
    tabId: 0,
    safe: false
});

export const setUfiUseLastRefill = (ufiUseLastRefill) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_SET_CONFIGURATION,
        params: {
            value: {
                ufi_use_last_refill: ufiUseLastRefill
            }
        }
    },
    method: handlers.MACHINE_SET_CONFIGURATION,
    tabId: 0,
    safe: false
});

export const loadMachineHistoryActions = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_HISTORY_ACTIONS,
        params: {
            offset: 0,
            rowCount: config.MAX_COLORANT_LIMIT
        }
    },
    method: handlers.MACHINE_HISTORY_ACTIONS,
    tabId: 0,
    safe: true
});
